/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {NotificationType} from './diplomat/enums/NotificationType';

export const EmailNotificationDefinition = yup.object({
   address: yup.string().email(),
   type: yup.string().oneOf(NotificationType.keys).default(NotificationType.enum.NOTIFY_ALWAYS),
   serverStartupEmails: yup.boolean().default(true),
   keyExpirationEmails: yup.boolean(),

   _id: yup.string(),
});
export type IEmailNotificationDefinition = yup.InferType<typeof EmailNotificationDefinition>;
